import { onboarding } from './onboarding';

/**
 * @todo THIS IS LEGACY AND SHOULD BE REFACTORED !
 * It contains code related to modals displayed in leads view and the onboarding for leads component
 */

/**
 * Init Deal Modal Component
 */
export const leadsModals = () => {
  if (document.querySelector('.onboarding')) {
    onboarding();
  }
};
